'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

let BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

RecursionService=function(_BaseService){_inherits(RecursionService,_BaseService);_createClass(RecursionService,null,[{key:'$inject',get:function()
{return['$compile']}}]);

function RecursionService($compile){_classCallCheck(this,RecursionService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));








_this.compile=function(element,link){

if(angular.isFunction(link)){
link={post:link};
}


var contents=element.contents().remove();
var compiledContents;

return{
pre:link&&link.pre?link.pre:null,
post:function(scope,element){

if(!compiledContents){
compiledContents=$compile(contents);
}

const childScope=scope.$new();
scope.$on('$destroy',function(){
if(!childScope){
return;
}
childScope.$destroy();
});

compiledContents(childScope,function(clone){return element.append(clone)});


if(link&&link.post){
link.post.apply(null,arguments);
}
}};

};return _this;
}return RecursionService}(BaseService);


module.exports=RecursionService;
//# sourceMappingURL=recursionService.js.map
